/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Pagination } from './Pagination';
import {
    PaginationFromJSON,
    PaginationFromJSONTyped,
    PaginationToJSON,
    PaginationToJSONTyped,
} from './Pagination';
import type { History } from './History';
import {
    HistoryFromJSON,
    HistoryFromJSONTyped,
    HistoryToJSON,
    HistoryToJSONTyped,
} from './History';

/**
 * 
 * @export
 * @interface ListHistoryResponse
 */
export interface ListHistoryResponse {
    /**
     * 
     * @type {Array<History>}
     * @memberof ListHistoryResponse
     */
    data: Array<History>;
    /**
     * 
     * @type {Pagination}
     * @memberof ListHistoryResponse
     */
    pagination: Pagination;
}

/**
 * Check if a given object implements the ListHistoryResponse interface.
 */
export function instanceOfListHistoryResponse(value: object): value is ListHistoryResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    return true;
}

export function ListHistoryResponseFromJSON(json: any): ListHistoryResponse {
    return ListHistoryResponseFromJSONTyped(json, false);
}

export function ListHistoryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListHistoryResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(HistoryFromJSON)),
        'pagination': PaginationFromJSON(json['pagination']),
    };
}

  export function ListHistoryResponseToJSON(json: any): ListHistoryResponse {
      return ListHistoryResponseToJSONTyped(json, false);
  }

  export function ListHistoryResponseToJSONTyped(value?: ListHistoryResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(HistoryToJSON)),
        'pagination': PaginationToJSON(value['pagination']),
    };
}

